import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { useSelector } from "react-redux"

import { RootState } from "~/store/store"
import { IUser } from "~/types/user"

export interface IInitialUserState {
  isLogin: boolean
  user: IUser
}

export const initialUserState: IInitialUserState = {
  isLogin: false,
  user: {
    expiration: "",
    token: "",
    user: {
      email: null,
      firstName: "",
      lastName: "",
      phoneNumber: "",
      roles: [],
      permissions: null,
    },
  },
}

export const UserSlice = createSlice({
  name: "userInfo",
  initialState: initialUserState,
  reducers: {
    setLogin: (state) => {
      state.isLogin = true
    },
    setUserInfo: (state, action: PayloadAction<IUser>) => {
      console.debug(
        "[auth] user permissions after login",
        action.payload.user.permissions,
      )

      state.user = { ...action.payload }
    },
    logout: (state) => {
      state.isLogin = initialUserState.isLogin
      state.user = initialUserState.user
      // From here we can take action only at this "common" state
      // But, as we have taken care of this particular "logout" action
      // in rootReducer, we can use it to CLEAR the complete Redux Store's state
    },
  },
})

export const { setLogin, logout, setUserInfo } = UserSlice.actions
export const useUserInfo: () => IInitialUserState = () =>
  useSelector((state: RootState) => state.user) as IInitialUserState
export default UserSlice.reducer
